Vue.component('IconNavigation', {
    props: ['config'],
    template: `
        <div class="IconNavigation">
            <h1 class="IconNavigation__header">{{ title }}</h1>
            <div class="IconNavigation__grid">
                <div v-for="item in contentLinks" @click="goto(item.contentLink)" class="IconNavigation__grid__item">
                    <img class="IconNavigation__grid__item__img" :src="item.iconSrc" />
                    <p class="IconNavigation__grid__item__text">{{ item.title }}</p>
                </div>
            </div>
        </div>
    `,
    data () {
        return {
            title: '',
            contentLinks: null,
        }
    },
    mounted () {
        if (this.config.title)
        {
            this.title = this.config.title
        }

        this.contentLinks = this.config.contentLinks.filter((item) => {
            if (item.icon !== null && item.title !== null && item.contentLink)
            {
                item.iconSrc = config.BACKGROUND_IMAGE_DIRECTORY + item.icon.src
                return item
            }
        })
    },
    methods: {
        goto (id) {
            const currentRoute = this.$router.currentRoute.path
            const contentRoute = currentRoute + ':' + id
            this.$router.push(contentRoute)
        }
    },
    computed: {}
});